import script from "./EditorToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&setup=true&lang=js"

import "./EditorToolbar.vue?vue&type=style&index=0&id=09a5807d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a5807d"]])

export default __exports__